import React, { useState, useEffect } from "react";
import MensajeCargando from "../../UI/MensajeCargando.js";
import MensajeError from "../../UI/MensajeError.js";
import { Torneo as Filtros } from "../../constantes/Filtros.js";
import * as TipoTorneo from "../../constantes/TipoTorneo.js";
import useGetListaURL from "../../../hooks/useGetListaURL.js";
import styles from "./ColumnaTorneosTipoInt.module.css";

const ColumnaTorneosTipoInt = (props) => {
  const categoria = props.categoria;
  const tipoTorneo = props.tipoTorneo;
  const [torneos, setTorneos] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const codCategoria = categoria ? categoria.codigo : null;
  const codTipoTorneo = tipoTorneo ? tipoTorneo.codigo : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (codCategoria && codTipoTorneo) {
      fetchData("torneos?categoria="+codCategoria+"&tipoTorneo="+codTipoTorneo, setTorneos);
    } else {
      setTorneos([]);
    }
  }, [codCategoria, codTipoTorneo, fetchData]);

  const onTorneoElegido = (torneo) => {
    const torneoElegido = {
      id: torneo.target.id,
      descripcion: torneo.target.value,
    };
    props.onDatoElegido(Filtros.TORNEO, torneoElegido);
  };

  return (
    <React.Fragment>
      {!isCargando && torneos.map((torneo) => (
        <button
          className={`${styles.torneo}`}
          key={torneo.id}
          id={torneo.id}
          onClick={onTorneoElegido}
          value={torneo.descripcion}
        >
          {torneo.descripcion}
        </button>
      ))}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ColumnaTorneosTipoInt;
